import React, { Fragment } from "react";
import JobPreview from "./JobPreview";
import { Section, Columns } from "react-bulma-components";
import BULMA_CONSTANTS from "react-bulma-components/lib/constants";

const { BREAKPOINTS } = BULMA_CONSTANTS;

// OPTIONAL: Flow type generated after running `yarn relay`, defining an Object type with shape of the fragment:
// import type {Todo_todo} from '../schema/schema';

const Jobs = ({ jobs }) => {
  return (
    <Fragment>
      <Section>
        <Columns>
          <Columns.Column size={6} offset={3}>
            {jobs?.map(job => (
              <JobPreview job={job} key={job.id} />
            ))}
          </Columns.Column>
        </Columns>
      </Section>
    </Fragment>
  );
};

export default Jobs;
